export default __webpack_public_path__ + "static/media/expl-gradcam_09_EN.ec402b05.png";